import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {Judi, JudiQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_BASE_API_URL
const URL = `${API_URL}/report/judi`

const getJudi = (query: string): Promise<JudiQueryResponse> => {
  return axios.get(`${URL}?${query}`).then((d: AxiosResponse<JudiQueryResponse>) => d.data)
}

const getJudiById = (id: ID): Promise<Judi | undefined> => {
  return axios
    .get(`${URL}/${id}`)
    .then((response: AxiosResponse<Response<Judi>>) => response.data)
    .then((response: Response<Judi>) => response.data)
}

const createJudi = (value: Judi): Promise<Judi | undefined> => {
  return axios
    .post(`${URL}`, value)
    .then((response: AxiosResponse<Response<Judi>>) => response.data)
    .then((response: Response<Judi>) => response.data)
}

const updateJudi = (value: Judi): Promise<any | undefined> => {
  return axios
    .put(`${URL}/${value.id}`, value)
    .then((response: AxiosResponse<Response<Judi>>) => response.data)
    .then((response: Response<Judi>) => response.data)
}

const deleteJudi = (id: ID): Promise<void> => {
  return axios.delete(`${URL}/${id}`).then(() => {})
}

const verifyJudi = (id: ID): Promise<void> => {
  return axios.put(`${URL}/verify/${id}`).then(() => {})
}

const rejectJudi = (id: ID): Promise<void> => {
  return axios.put(`${URL}/reject/${id}`).then(() => {})
}

const setDraftJudi = (id: ID): Promise<void> => {
  return axios.put(`${URL}/set-draft/${id}`).then(() => {})
}

export {getJudi, getJudiById, updateJudi, deleteJudi, createJudi, verifyJudi, rejectJudi, setDraftJudi}
